import { useEffect, useState, useRef } from 'react';
import { OrganizationApi } from '../../../api';
import { useContainer } from '../../useContainer';
import { dispatch } from '../../../store';
import { setHolidays } from '../../../store/slices/holiday.slice';
import { HolidaysWithBranchesDto } from '../../../commonTypes/organization.types';

const useHttpGetHolidaysByYearsOnMount = (years: number[]) => {
    const organizationApi: OrganizationApi = useContainer(OrganizationApi);
    const [isReady, setIsReady] = useState(false);
    const currentYearsRef = useRef<string>('');

    useEffect(() => {
        if (years.length === 0) {
            setIsReady(true);
            return;
        }

        const uniqueYears = [...new Set(years)].sort();
        const yearsKey = uniqueYears.join(',');

        if (currentYearsRef.current === yearsKey) {
            return;
        }

        currentYearsRef.current = yearsKey;
        setIsReady(false);

        const allHolidays: HolidaysWithBranchesDto[] = [];
        let completedCount = 0;
        const totalToFetch = uniqueYears.length;

        if (totalToFetch === 0) {
            setIsReady(true);
            return;
        }

        uniqueYears.forEach(year => {
            const { exec } = organizationApi.getHolidaysByYear({
                query: {
                    year,
                },
                onSuccess: res => {
                    if (currentYearsRef.current !== yearsKey) {
                        return;
                    }

                    allHolidays.push(...res.body);
                    completedCount++;

                    if (completedCount === totalToFetch) {
                        const uniqueHolidays = allHolidays.reduce((acc, holiday) => {
                            if (!acc.find(h => h.id === holiday.id)) {
                                acc.push(holiday);
                            }
                            return acc;
                        }, [] as HolidaysWithBranchesDto[]);

                        if (currentYearsRef.current === yearsKey) {
                            dispatch(setHolidays(uniqueHolidays));
                            setIsReady(true);
                        }
                    }
                },
                onError: error => {
                    console.log(error);
                    if (currentYearsRef.current !== yearsKey) {
                        return;
                    }

                    completedCount++;
                    if (completedCount === totalToFetch) {
                        const uniqueHolidays = allHolidays.reduce((acc, holiday) => {
                            if (!acc.find(h => h.id === holiday.id)) {
                                acc.push(holiday);
                            }
                            return acc;
                        }, [] as HolidaysWithBranchesDto[]);

                        if (currentYearsRef.current === yearsKey) {
                            dispatch(setHolidays(uniqueHolidays));
                            setIsReady(true);
                        }
                    }
                },
            });
            exec();
        });
    }, [years.join(',')]);

    return { isReady };
};

export default useHttpGetHolidaysByYearsOnMount;
